import React, { useContext } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { ThemeContext } from 'styled-components';
import axios from 'axios';

import 'src/styles/App.scss';

import lightTheme, { darkTheme } from 'src/theme';

import { GlobalStyle } from 'src/GlobalStyle';
import { DarkmodeContext } from 'src/contexts/dark-mode';
import AppRouter from 'src/AppRouter';

// https://axios-http.com/docs/interceptors
axios.interceptors.response.use(
  (response) => {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  (error) => {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    if (error.response.status === 401) {
      window.location.assign('/login');
    }
    return Promise.reject(error);
  }
);

function App() {
  const { isDarkmode } = useContext(DarkmodeContext);

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        retryDelay: 500,
      },
    },
  });

  const theme = isDarkmode ? darkTheme : lightTheme;

  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeContext.Provider value={theme}>
          <GlobalStyle />
          <AppRouter />
        </ThemeContext.Provider>

        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </React.StrictMode>
  );
}

export default App;
